// Expose jQuery globally so the app scripts (and any inline scripts) can use $
import jquery from "jquery"

window.jQuery = jquery
window.$ = jquery
